import * as React from "react"
import { useRef, useEffect } from "react"
import PortableText from "@sanity/block-content-to-react"

// Styles
import "./_project-info.scss"

// Components
import { Section, Container } from "../StyledComponents/layoutComponentStyles"
import { postSerializer } from "../../utils/blockContentSerializer"

// Animations
import { SplitText } from "gsap/SplitText"
import { gsap } from "gsap"
import { createTriggerRevealTitle } from "../../animations/globalAnims"
import { descStagger, infoStagger } from "../../animations/pages/workAnim"

interface ProjectInfoProps {
  module: any
  project: any
}

/*









*/

const ProjectInfo: React.FunctionComponent<ProjectInfoProps> = ({ project, module }) => {
  // Create array of sevices
  const servicesList = []
  for (let i = 0; i < module.services.length; i++) {
    servicesList.push(module.services[i].title)
  }

  // Refs
  const heroTitleRef = useRef<HTMLHeadingElement>(null)

  // Effects
  useEffect(() => {
    const descChildren = document.querySelector(".c-project-desc__inner")?.children
    const pars: Array<Element> = Array.from(descChildren ? descChildren : [])
    const splitPars: Array<Element> = []
    const info = gsap.utils.toArray(".c-project-detail")

    createTriggerRevealTitle(heroTitleRef.current)
    infoStagger(info)

    if (document.fonts) {
      document.fonts.ready.then(() => {
        pars.forEach(par => {
          const split = new SplitText(par, { type: "lines" })
          splitPars.push(...split.lines)
        })

        descStagger(splitPars)
      })
    } else {
      setTimeout(() => {
        pars.forEach(par => {
          const split = new SplitText(par, { type: "lines" })
          splitPars.push(...split.lines)
        })
        descStagger(splitPars)
      }, 250)
    }
  }, [])

  return (
    <Section>
      <Container fourteenClm>
        <div className='c-project-info'>
          <h1 className='o-type-xl' ref={heroTitleRef}>
            {project.tagline}
          </h1>

          <div className='c-project-info__content'>
            <div className='c-project-details'>
              <div className='c-project-detail'>
                <p>Client:</p>
                <p>{module.client}</p>
              </div>
              <div className='c-project-detail'>
                <p>Services:</p>
                <p>{servicesList.join(", ")}</p>
              </div>
              <div className='c-project-detail'>
                <p>Location:</p>
                <p>{module.location}</p>
              </div>
              <div className='c-project-detail'>
                <p>Date:</p>
                <p>{module.dateCompleted}</p>
              </div>
            </div>
            <div className='c-project-desc'>
              <PortableText blocks={module._rawDescription} serializers={postSerializer} className='c-project-desc__inner' />
            </div>
          </div>
        </div>
      </Container>
    </Section>
  )
}

export default ProjectInfo
